<div class="months">
	<div class="arrows" [ngClass]="{ top: sticky }">
		<div (click)="onDateMove(-7)">
			<i class="fas fa-angle-double-left"></i>
		</div>
		<div class="right" (click)="onDateMove(7)">
			<i class="fas fa-angle-double-right"></i>
		</div>
	</div>
	<div class="month" *ngFor="let month of months">
		<div class="title">{{ month.name }}</div>
		<ul class="days checkers">
			<li *ngFor="let day of counter(month.days, month.from)" (click)="dayClicked(month, day)">
				<div *ngIf="selectedColumns.includes(month.name + '-' + day)" class="selectedColumn"></div>
				{{ day }}
			</li>
		</ul>
	</div>
</div>
